import { useRef, useState } from "react"
import CustomTAndAWrapper from "../../components/CustomTAndAWrapper"
import SetupSteps from "../../components/SetupSteps"
import CreateShiftPlan from "../../setup/components/CreateShiftPlan"
import { useNavigate, useParams } from "react-router-dom"

const SETUP_STEPS = [
  "Plan name & type",
  "Configuration",
  "Shift periods",
  "Shift tables",
]

const CreateShiftPlanWorkplace = () => {
  const params = useParams()
  const workplaceId = params.x
  const [currentStep, setCurrentStep] = useState(0)

  const handleTrackProgress = (updates: Record<string, boolean>) => {
    if (updates.shiftPlanConfigured) setCurrentStep(1)
    if (updates.shiftPermissionsConfigured) setCurrentStep(2)
    if (updates.shiftPeriodConfigured) setCurrentStep(3)
    if (updates.shiftEmployeesConfigured) setCurrentStep(4)
    return true
  }
  const navigate = useNavigate()
  return (
    <CustomTAndAWrapper>
      <div className="flex flex-col gap-2 h-[calc(100vh-80px)] lg:flex-row">
        <SetupSteps
          steps={SETUP_STEPS}
          currentStep={currentStep}
        />
        <main className="flex-1 min-w-0 bg-white rounded-md py-4 px-4 md:py-6 md:px-6 flex flex-col min-h-0 overflow-hidden relative">
          <CreateShiftPlan
            workplaceId={workplaceId ? Number(workplaceId) : undefined}
            onBack={() =>
              navigate(
                `/dashboard/time-and-attendance/view-workplace/${workplaceId}`
              )
            }
            onComplete={() =>
              navigate(
                `/dashboard/time-and-attendance/view-workplace/${workplaceId}`
              )
            }
            onTrackProgress={handleTrackProgress}
          />
        </main>
      </div>
    </CustomTAndAWrapper>
  )
}

export default CreateShiftPlanWorkplace
